module.exports = __webpack_public_path__ + "p4_img1.jpg?2afef89d37c6c28e85f99183be6300aa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p4/p4_img1.jpg
// module id = 108
// module chunks = 0